import React, { useEffect, useState } from "react";
import InsightCard from "../insights-in-use/InsightCard";
import {
  IBlogCategory,
  IInsights,
  fetchExploreInsightsApiCall,
  fetchInsightsApiCall,
} from "../insights-in-use/InsightsController";
import usePaginationHook from "../../hooks/UsePaginationHook";
import { PAGINATION_PER_PAGE_ROWS } from "../../utils/AppConstants";
import { IPagination } from "../../data/AppInterface";
import InsightViewSkeleton from "./insights-skeleton/InsightsViewSkeleton";
import UseTranslationHook from "../../hooks/UseTranslationHook";

interface IExploreProps {
  category_id: number | null;
  blog_id: number | undefined;
}
const ExploreView: React.FC<IExploreProps> = ({ category_id, blog_id }) => {
  const [insightsList, setInsightsList] = useState<IInsights[]>([]);
  const [buffer, setBuffer] = useState(true);
  const [loading, setLoading] = useState(true);
  const { pagination, setPagination } = usePaginationHook({
    pagination: {
      per_page_rows: Number(PAGINATION_PER_PAGE_ROWS.Four),
      current_page: 1,
      sort_by: "",
      order_by: "DESC",
    },
  });
  let timer: NodeJS.Timeout;
  const { t } = UseTranslationHook();

  const fetchInsightList = async (
    payloadPagination: IPagination,
    insights: IInsights[],
    category_id: number | null,
    blog_id: number | undefined
  ) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(async () => {
      await fetchExploreInsightsApiCall(
        setInsightsList,
        setLoading,
        setPagination,
        payloadPagination,
        insights,
        setBuffer,
        category_id,
        blog_id
      );
    }, 500);
  };
  useEffect(() => {
    fetchInsightList(
      { ...pagination, current_page: 1 },
      insightsList,
      category_id,
      blog_id
    );
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [blog_id]);

  return (
    <div>
      {insightsList && insightsList.length > 0 && (
        <>
          <div className="text-skin-title-insights text-center lg:text-5xl text-2xl">
            {t("explore_more")}
          </div>
          <div className="grid grid-cols-12 gap-6 mt-8 mb-6">
            {loading ? (
              [...Array(3)].map((_, index) => (
                <InsightViewSkeleton key={index} />
              ))
            ) : insightsList.length > 0 ? (
              insightsList
                .slice(0, 3)
                .map((item, index) => <InsightCard item={item} key={index} />)
            ) : (
              <div className="text-white col-span-12 text-center">
                {t("no_blog")}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default ExploreView;
